import styled from "styled-components/macro";

const IconContainer = styled.svg`
		fill: ${({ theme, fillColor }) => fillColor ? fillColor : theme.primaryColor};
`;

export default IconContainer;